import {
  ScrollActionPayload,
  SCROLL_COMPLETE,
  SCROLL_TO,
  TRIP_TRAVELLER_TYPE,
  SET_ACCORDION_OPEN,
  CLEAR_ACCORDION_OPEN,
  TRAVELLER_FORM_ERRORS,
  TRAVELLER_PAYMENT,
  TravellerJourneyPayload,
  TRAVELLER_JOURNEY_SELECTION,
  ACCEPT_LEGAL,
  SELECT_PLAN_PAGE_FOCUS,
  COVERME_TRIP_TRAVELLER_TYPE
} from './types';
import { Dispatch } from 'redux';
import { ReduxStore } from '../payload-types';
import { get } from 'lodash';
import { checkTrue } from '@trip-ux/common';

export const scrollTo =
  (payload: ScrollActionPayload) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: SCROLL_TO,
      payload
    });
  };

export const scrollComplete =
  () =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: SCROLL_COMPLETE
    });
  };

export const setTripTravellerType =
  () =>
  (dispatch: Dispatch, getState: () => ReduxStore): void => {
    const quickQuoteForm = getState().quoteForm.form;
    dispatch({
      type: TRIP_TRAVELLER_TYPE,
      payload: {
        isFamily: checkTrue(get(quickQuoteForm, 'familyPlans')),
        isSingleTrip: !checkTrue(get(quickQuoteForm, 'multiTrip'))
      }
    });
  };

export const setCoverMeTripTravellerType =
  () =>
  (dispatch: Dispatch, getState: () => ReduxStore): void => {
    const quickQuoteForm = getState().quoteForm.form;
    dispatch({
      type: COVERME_TRIP_TRAVELLER_TYPE,
      payload: {
        isFamily: quickQuoteForm.isFamily
      }
    });
  };

export const toggleAccordion =
  (paxId: number) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: SET_ACCORDION_OPEN,
      payload: paxId
    });
  };

export const clearAccordion =
  () =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: CLEAR_ACCORDION_OPEN
    });
  };

export const setTravellerFormError =
  (hasError: boolean) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: TRAVELLER_FORM_ERRORS,
      payload: hasError
    });
  };

export const setTravellerPayment =
  (payload: string) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: TRAVELLER_PAYMENT,
      payload
    });
  };

export const setTravellerJourney =
  (payload: TravellerJourneyPayload) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: TRAVELLER_JOURNEY_SELECTION,
      payload
    });
  };

export const acceptLegal =
  (payload: boolean) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: ACCEPT_LEGAL,
      payload
    });
  };

export const setSelectPlanPageFocus = (id: string) => (dispatch: Dispatch, getState: () => ReduxStore) => {
  dispatch({
    type: SELECT_PLAN_PAGE_FOCUS,
    payload: id
  });
};
